/**
 * @generated SignedSource<<3b17a2a03e4251467ad50496cba87c18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_viewer$data = {
  readonly isPdpStfEnabled?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_viewer">;
  readonly " $fragmentType": "PdpSharedIconBubbleEmail_viewer";
};
export type PdpSharedIconBubbleEmail_viewer$key = {
  readonly " $data"?: PdpSharedIconBubbleEmail_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleEmail_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpStfEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "enablePdpStf"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"enablePdpStf\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSendToFriendModalLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f4c0984c1d3795fc70c1068b9baf81be";

export default node;
